/**
 * @description - env name (prod, preprod, ...)\
 * earlier this was used for S3 buckets but now its being used for generic purposes
 */
export const exly_env_name =
  process.env.REACT_APP_EXLY_S3_BUCKET_WATERMARK_ENV_NAME;
